import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  Tabs,
  TabList,
  Tab,
  FilterSelect,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';

import { PortfolioMontlhyStatementListFilterOption } from '@/modules/wealth/services/portfolio';

interface Props {
  currentTabIndex: number;
  selectedYear?: number | string | null;
  yearOptions: PortfolioMontlhyStatementListFilterOption[];
  isLoading: boolean;
}
interface Emits {
  (event: 'on-change-tab', tabIndex: number): void;
  (event: 'on-change-year', year: number | string): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    currentTabIndex: null,
    selectedYear: null,
    yearOptions: null,
    isLoading: { type: Boolean }
  },
  emits: ["on-change-tab", "on-change-year"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'on-change-tab', tabIndex: number): void;
  (event: 'on-change-year', year: number | string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  currentTabIndex: number;
  selectedYear?: number | string | null;
  yearOptions: PortfolioMontlhyStatementListFilterOption[];
  isLoading: boolean;
}





// const isExportButtonLoading = ref(false);

const onChangeTab = (tabIndex: number) => {
  emit('on-change-tab', tabIndex);
};

const onChangeYear = (year: number | string) => {
  emit('on-change-year', year);
};

// const handleExport = () => {
//   // TO-DO: Implement export logic
//   isExportButtonLoading.value = true;
//   setTimeout(() => {
//     isExportButtonLoading.value = false;
//   }, 2000);
// };

const shouldShowFilters = computed(
  () => props.isLoading || props.yearOptions?.length > 0
);

return { __sfc: true,props, emit, onChangeTab, onChangeYear, shouldShowFilters, Tabs, TabList, Tab, FilterSelect, SkeletonLoader }
}

})